module.exports = __webpack_public_path__ + "static/media/bo.2b6773a9.svg";